/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import {
  HeaderContainer,
  HeaderInner,
  Logo,
  Nav,
  Arrow,
  HeaderContentWrapper,
} from "styles/components/common/HeaderStyle";
import logo from "assets/logo.svg";
import { Link } from "react-router-dom";
import { useNavigate, useLocation } from "react-router-dom";

const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [previousPage, setPreviousPage] = useState(null);

  const rootPage = ["/", "/home/refill", "/guide", "/setting", "/my", "/login"];
  const hasBack =
    location.pathname !== rootPage.find((page) => page === location.pathname) &&
    previousPage !== null;
  const isHome =
    location.pathname === "/" || location.pathname.includes("/home");
  const goBack = () => {
    navigate(-1);
  };

  useEffect(() => {
      // 브라우저 뒤로가기 버튼 클릭을 감지하는 이벤트 리스너 추가
      const handlePopState = (event) => {
        event.preventDefault();

        if (hasBack) {
          goBack();
        } else {
          navigate('/home');
        }
      };
  
      window.addEventListener("popstate", handlePopState);
  
      // cleanup 함수: 컴포넌트 언마운트 시 리스너 제거
      return () => {
        window.removeEventListener("popstate", handlePopState);
      };
  }, [])
  
  useEffect(() => {
    setPreviousPage(location.pathname);
  }, [location]);

  return (
    <HeaderContainer>
      <HeaderInner>
        <HeaderContentWrapper>
          <Nav>
            {hasBack && <Arrow alt="뒤로가기" onClick={goBack} />}
            <Link to="/">
              <Logo src={logo} alt="Pixcy Logo" />
            </Link>
          </Nav>
          {isHome && (
            <Nav>
              <Link to="/home/detergent">픽시 세탁세제</Link>
              <Link to="/home/history">이용내역</Link>
              {/* <Link>리뷰</Link> */}
            </Nav>
          )}
        </HeaderContentWrapper>
      </HeaderInner>
    </HeaderContainer>
  );
};

export default Header;
